import '../../../../vendor/assets/javascripts/jquery-ui';
